
import ActionMixins from '@/pagemixins/event/id';
import Comment from '@/components/comment/index';
export default {
  components: {
    Comment
  },
  mixins: [ActionMixins]
}
